const trackUser = identifier => window._paq?.push(['setUserId', identifier]);

export default trackUser;
